import React from 'react';

import css from './Badge.module.css';

export const Badge = ({ badge }) => {
  return (
    <span className={css.badge} data-type={badge.type}>
      {badge.display}
    </span>
  );
};
